<template>
	<div>
		<v-row v-for="documento in documentos" :key="documento.id" style="margin: 15px 10px;">
			<v-row no-gutter>
				<v-col cols="12" no-gutter>
					<FileUploader :idCampo="idCampo" :idCombinacion="idCombinacion" :idSolicitud="documento.idSolicitud"
						:idSubsanarTipoDocumento="documento.idSubsaTipoDocumento" :idSolDocumento="documento.idSolDocumento"
						:idTipoDocumento="documento.idTipoDocumento" :nombreArchivo="documento.nombreArchivo"
						:titulo="documento.titulo" :obligatorio="documento.obligatorio" show-size
						@uploaded="$emit('documento-changed', $event)" @deleted="$emit('documento-changed', $event)" />
				</v-col>
				<v-col v-if="textoAyuda || documento.hasImagenEjemplo" class="mt-n4 ml-13 mb-4 pa-0">
					<a class="btn-link" @click="verEjemplo(documento)">
						Ayuda
					</a>
				</v-col>
			</v-row>
		</v-row>
		<ImageDialog ref="dlgImage" />
	</div>
</template>

<script>
import api from '@Base/services/auditoriaService';
import FileUploader from './FileUploader.vue';
import ImageDialog from './ImageDialog.vue';

export default {
	name: 'ListaDocumentos',
	components: {
		FileUploader, ImageDialog
	},
	props: ['idCampo', 'idCombinacion', 'textoAyuda', 'documentos'],
	data() {
		return {
			verEjemplo(documento) {
				if (documento.imagenEjemplo) {
					this.$refs.dlgImage.open(documento.titulo, documento.imagenEjemplo, this.textoAyuda);
					return;
				}

				api.getImagenEjemploDeDocumento(documento.idSubsaTipoDocumento,
					res => {
						if (res) {
							documento.imagenEjemplo = `data:image/jpeg;base64,${res}`;
						}
						this.$refs.dlgImage.open(documento.titulo, documento.imagenEjemplo, this.textoAyuda);
					},
					error => {
					});
			}
		}
	}
}
</script>

<style scoped>
.disabled {
	pointer-events: none;
	opacity: .5;
}
</style>